import React from "react";

import BlogModel from "../components/aszf copy/blog";

const Blog = () => {
  return <BlogModel />;
};

export default Blog;
